import UUIDBase from '../UUIDBase'

export default class ItemSerial extends UUIDBase {
  static ENDPOINT = '/inventory/itemserials'
  ItemStockID = ''

  constructor(number: string) {
    super()
    this.number = number
  }

  number = ''
  used?: Date
  Missing?: Date
}
